import { createApp, ref } from 'vue';
import {} from '@ts/common/datasets';
import { fetchData, HttpError, isHttpErrorWithStatus, isObject } from '@ts/common/request';
import { getLocale } from '@ts/common/language';
import { globalVueProperties, registerComponents } from '@ts/common/vue';
import '@ts/pages/page-defaults';
function getHashIds(componentDataElm) {
    return JSON.parse(componentDataElm.getAttribute('data-hash-ids') ?? '[]');
}
const componentDataElm = document.getElementById('component-data');
const hashIds = componentDataElm ? getHashIds(componentDataElm) : [];
const app = createApp({
    setup() {
        const dataContainer = ref({});
        for (const hashId of hashIds) {
            fetchDataForHashId(hashId);
        }
        async function fetchDataForHashId(hashId, force = false) {
            if (hashId.length !== 12)
                return;
            if (force == false && hashId in dataContainer.value)
                return;
            try {
                const responseData = await fetchData('/api/v1/analyses/' + hashId + '?locale=' + getLocale(), {
                    headers: {
                        Accept: 'application/json',
                    },
                    method: 'GET',
                });
                if (isObject(responseData)) {
                    dataContainer.value[hashId] = responseData;
                }
                else {
                    throw new HttpError(500, 'Invalid response from server', responseData);
                }
            }
            catch (error) {
                if (isHttpErrorWithStatus(error, 401)) {
                    window.location.href = '/' + getLocale() + '/login';
                    console.warn('Unauthorized. Redirecting to login.');
                }
                else if (isHttpErrorWithStatus(error, 408)) {
                    console.warn('Request timed out. Retrying...');
                }
                else {
                    console.error('Error fetching data for hashId ' + hashId, error);
                }
            }
        }
        return {
            dataContainer,
        };
    },
});
Object.assign(app.config.globalProperties, globalVueProperties());
if (hashIds.length > 0) {
    registerComponents(app);
}
app.mount('#content');
const mathContentEl = document.querySelector('[data-has-math]');
if (mathContentEl) {
    Promise.all([import('katex/dist/katex.min.css'), import('katex/dist/contrib/auto-render.min.js')]).then(([, autoRenderModule]) => {
        const renderMathInElement = autoRenderModule.default;
        renderMathInElement(mathContentEl, {
            delimiters: [
                { left: '$$', right: '$$', display: true },
                { left: '$', right: '$', display: false },
            ],
            throwOnError: false,
        });
    });
}
